import React from "react";
import RaffleInfoScreen from "./RaffleInfoScreen";

type Props = {
  onClickGoBack: () => void;
};

export default function RaffleInfoActivity(props: Props) {
  return <RaffleInfoScreen onClickGoBack={props.onClickGoBack} />;
}
